import React, { useState, useEffect }from 'react';
import {
  DialogContent,
  CardContent,
  Card,
  makeStyles,
  TableRow,
  Grid,
  TableBody,
  Table,
} from "@material-ui/core";
import { KisshtDialog } from "components/custom/KisshtDialog";
import Spin from "components/ui/Spin";
import {viewBankDetails} from "../../../shared/api/purple/outbondPayment";
import TableBodyCell from "components/table/TableBodyCell";
import { BootstrapBadge } from "components/ui/BootstrapBadge";

export const ResponseMsg = (props) => {
  const { visible, handleDialogClose} = props;
  let bankId  = props.data;
  const [spinning, setspinning] = useState(false);
  const [bankData, setBankData] = useState("");
  const useStyle = makeStyles((theme) => ({
    table: {
      marginBottom: "1rem",
    },
    card: {
      "& .MuiCardHeader-root": {
        padding: "12px",
        paddingBottom: 0,
      },
      "& .MuiCardContent-root": {
        padding: 0,
      },
    },
  }));
  const classes = useStyle();

  const handleClose = (_) => {
    handleDialogClose(false);
  };

  useEffect(() => {
    viewBankHandle(bankId)
    // eslint-disable-next-line
  }, []);

  const viewBankHandle = (bankId)=>{
    viewBankDetails(bankId).then((res) =>{
      setspinning(false);
      if (res.hasOwnProperty("success") && res.success) {
        const data = res.data.res;
        if(data){
          setBankData(data)
        }
      }
    })
  }

  return (
    <Spin spinning={spinning}>
      <KisshtDialog
        title="User Bank Details View"
        maxWidth={"md"}
        open={visible}
        handleClose={handleClose}
      >
        <DialogContent>
          <Card className={classes.card}>
            <CardContent>             
             <Grid container flex-direction="row">
                <Grid item xs={12} >
                        <Table className={classes.table} style={{width:'100%'}}>
                        {/* <p style={{padding:'10px 0'}}>User Bank Details View</p> */}
                        <TableBody>
                        <TableRow>
                                <TableBodyCell className="font-semibold" style={{width:'40%'}}>User Reference Number</TableBodyCell>
                                <TableBodyCell>{bankData[0]?.user_reference_number}</TableBodyCell>
                        </TableRow>
                        <TableRow>
                                <TableBodyCell className="font-semibold" style={{width:'40%'}}>User Type</TableBodyCell>
                                <TableBodyCell>{bankData[0]?.type}</TableBodyCell>
                        </TableRow>
                        <TableRow>
                                <TableBodyCell className="font-semibold" style={{width:'40%'}}>Bank Name</TableBodyCell>
                                <TableBodyCell>{bankData[0]?.bank}</TableBodyCell>
                        </TableRow>
                        <TableRow>
                                <TableBodyCell className="font-semibold" style={{width:'40%'}}>	Bank Account Number</TableBodyCell>
                                <TableBodyCell>{bankData[0]?.bank_account_no}</TableBodyCell>
                        </TableRow>
                        <TableRow>
                                <TableBodyCell className="font-semibold" style={{width:'40%'}}>Bank Account Holder Name</TableBodyCell>
                                <TableBodyCell>{bankData[0]?.bank_account_holder_name}</TableBodyCell>
                        </TableRow>

                        <TableRow>
                                <TableBodyCell className="font-semibold" style={{width:'40%'}}>Bank Branch</TableBodyCell>
                                <TableBodyCell>{bankData[0]?.bank_branch}</TableBodyCell>
                        </TableRow>
                        <TableRow>
                                <TableBodyCell className="font-semibold" style={{width:'40%'}}>Bank IFSC Code</TableBodyCell>
                                <TableBodyCell>{bankData[0]?.bank_branch_ifsc}</TableBodyCell>
                        </TableRow>
                        <TableRow>
                                <TableBodyCell className="font-semibold" style={{width:'40%'}}>Bank Account Type</TableBodyCell>
                                <TableBodyCell>{bankData[0]?.bank_account_type}</TableBodyCell>
                        </TableRow>
                        <TableRow>
                                <TableBodyCell className="font-semibold" style={{width:'40%'}}>	Bank MICR Code</TableBodyCell>
                                <TableBodyCell>{bankData[0]?.bank_micr_code}</TableBodyCell>
                        </TableRow>
                        <TableRow>
                                <TableBodyCell className="font-semibold" style={{width:'40%'}}>Bank Verified</TableBodyCell>
                                {bankData[0]?.is_verified !== 1 ?                                 
                                <TableBodyCell>
                                <BootstrapBadge
                                  backgroundColor="green"
                                  color="#fff"
                                  text="NO"
                                ></BootstrapBadge>
                                </TableBodyCell>:
                                <TableBodyCell>
                                <BootstrapBadge
                                 backgroundColor="green"
                                 color="#fff"
                                 text="YES"
                                ></BootstrapBadge>
                                </TableBodyCell>}
                        </TableRow>
                        <TableRow>
                                <TableBodyCell className="font-semibold" style={{width:'40%'}}>Verified Name</TableBodyCell>
                                <TableBodyCell>
                                <div>
                                  <div>
                                  <p>{bankData[0]?.verified_name}</p>
                                  </div>
                                  <div>
                                  <p style={{fontSize:"13px",color:"gray",paddingTop:"5px"}}> (TXN:{bankData[0]?.idfc_reference_number})</p>
                                  </div>
                                </div>    
                                </TableBodyCell>
                             
                        </TableRow>
                        <TableRow>
                                <TableBodyCell className="font-semibold" style={{width:'40%'}}>	Verification Type</TableBodyCell>
                                <TableBodyCell>{bankData[0]?.verification_type}</TableBodyCell>
                        </TableRow>
                        <TableRow>
                                <TableBodyCell className="font-semibold" style={{width:'40%'}}>Verification Name Match %</TableBodyCell>
                                <TableBodyCell>{bankData[0]?.verified_name_match}</TableBodyCell>
                        </TableRow>

                        <TableRow>
                                <TableBodyCell className="font-semibold" style={{width:'40%'}}>IMPS verified</TableBodyCell>
                                <TableBodyCell>{bankData[0]?.is_imps_verified}</TableBodyCell>
                        </TableRow>
                        <TableRow>
                                <TableBodyCell className="font-semibold" style={{width:'40%'}}>Is nach Blocked?</TableBodyCell>
                                <TableBodyCell>{bankData[0]?.is_nach_blocked}</TableBodyCell>
                        </TableRow>
                        <TableRow>
                                <TableBodyCell className="font-semibold" style={{width:'40%'}}>Nach Blocked Reason</TableBodyCell>
                                <TableBodyCell>{bankData[0]?.nach_blocked_reason}</TableBodyCell>
                        </TableRow>
                        <TableRow>
                                <TableBodyCell className="font-semibold" style={{width:'40%'}}>Created At</TableBodyCell>
                                <TableBodyCell>{bankData[0]?.created_at}</TableBodyCell>
                        </TableRow>
                        <TableRow>
                                <TableBodyCell className="font-semibold" style={{width:'40%'}}>Updated At</TableBodyCell>
                                <TableBodyCell>{bankData[0]?.updated_at}</TableBodyCell>
                        </TableRow>
                        </TableBody>
                        </Table>
                </Grid>
                </Grid>
            </CardContent>
          </Card>
        </DialogContent>
      </KisshtDialog>
    </Spin>
  );
};
export default ResponseMsg;